/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { editBeneficiary } from "../../../../redux/features/accounts/beneficiaryAccount/createAccount";
import { viewAccountDetail } from "../../../../redux/features/verifyPAN/verifyPAN";

import ICONS from "../../../../assets/Icons";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import CommonToast from "../../../../components/_utils/CommonToast";
import {
  buildSwitchFieldForceEditPayload,
  persistFieldForceCreateError,
} from "../../../../utils/fieldForceCreateError";
import { createFieldForceAccount } from "../../../../redux/features/accounts/fieldForceAccount";
import FieldForceContactDetails from "../../../../components/Accounts/FieldForceAccount/FieldForceAccountCreate/FieldForceContactDetails";
import FieldForceAccountName from "../../../../components/Accounts/FieldForceAccount/FieldForceAccountCreate/FieldForceAccountName";
import FieldForceCategoryAndLabels from "../../../../components/Accounts/FieldForceAccount/FieldForceCategoryAndLabels";
import FieldForceConfirmAccount from "../../../../components/Accounts/FieldForceAccount/FieldForceConfirmAccount";
import FieldFieldBankDetails from "../../../../components/Accounts/FieldForceAccount/FieldForceAccountCreate/FieldFieldBankDetails";
import {
  bankLookUp,
  getAllCategories,
  getIFSCDetails,
  panLookUp,
  resetBankVerificationError,
  resetGSTVerification,
  resetPanLookup,
  resetPANVerification,
  verifyBankAccount,
  verifyPAN,
} from "../../../../redux/features/sharedResources/sharedResources";
import SmallPopup from "../../../../components/_utils/CommonSmallPopup";
import SmallPopupWithBulletPoints from "../../../../components/_utils/CommonSmallPopupWithBulletPoint";
import PrimaryStepper from "../../../../components/_utils/CommonSteppers/PrimaryStepper";
import SVGComponent from "../../../../components/_utils/SVGComponent";
import CreateFieldForcePanDetails from "../../../../components/Accounts/FieldForceAccount/FieldForceAccountCreate/CreateFieldForcePanDetails";

const FieldForceAccountCreate = ({ flow }) => {
  const scrollIt = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const userData = location?.state;
  const bene_acc_id = userData?.id;
  const [nextButtonEnabled, BenEnableNextButton] = useState(true);

  const [lookupNext, setLookupNext] = useState(false);
  const [disableCreateNext, setDisableCreateNext] = useState(false);
  const [bankAccountName, setBankAccountName] = useState("");
  const [activeStep, setActiveStep] = useState(
    GlobalConfiguration.lengthCheckZero,
  );

  const [bankLookupNext, setBankLookupNext] = useState(false);

  const [hideBankBlock, setBankHideBlock] = useState(false);
  const [isButtonDisabled] = useState(false);
  const [selectedFields, setSelectedFields] = useState([]);
  const [verifiedPan, setVerifiedPan] = useState(null);

  const [hideBlock, setHideBlock] = useState(false);

  const [selectedLabelsCreate, setSelectedLabelsCreate] = useState([]);
  const [contactBol, setContactBol] = useState({
    email: "",
    contact: "",
    accountname: "",
  });
  const [bankUserInfo, setBankUserInfo] = useState([]);

  const [GSTStatus, setGSTStatus] = useState(null);
  const [bankVerificationStatus, setBankVerificationStatus] = useState(false);

  const [payload, setPayload] = useState({
    bank_account: userData?.bank_acc_no || "",
    ifsc_code: userData?.ifsc_code || "",
    contact_no: userData?.contact_no || "",
    email_id: userData?.email_id || "",
    gstin: userData?.gstin || userData?.gstin_no || "",
    name: userData?.name || "",
    categories: userData?.category || "",
    panNumber: userData?.pan || "",
    gst_org_name: "",
    account_name: userData?.name || "",
    labels: userData?.labels || [],
    recipient_email: "",
    reimbursement_account: flow === "reimbursement" ? true : false,
    reimbursement_user_id: "",
    userName: "",
    userId: "",
    amount: GlobalConfiguration.defaultAmount,
    virtual: "",
  });
  const [manualVirtualAccount, setManualVirtualAccount] = useState(false);

  const {
    verifyBankAccountError,
    verifyBankAccountData,
    verifyBankAccountLoading,
    bankLookupData,
    bankLookupLoading,
    panLookupData,
    panLookupLoading,
    panLookupError,
    panVerificationData,
    panVerificationLoading,
    categoriesData,
    ifscDetailsData,
    ifscDetailsError,
    ifscDetailsLoading,
  } = useSelector((state) => state.sharedResources);

  const categories = categoriesData?.categories?.filter(
    (cat) => cat?.active === "Y",
  );

  const { createFieldForceAccountLoading } = useSelector(
    (state) => state.fieldForceAccount,
  );

  const { services, isLoading } = useSelector((state) => state.refreshToken);

  const [showModalPopup, setShowModalPopup] = useState(false);
  const [exitFlow, setExitFlow] = useState(false);
  const [showAlertCategories, setShowAlertCategories] = useState(false);
  const [selectedValue, setSelectedValue] = useState("legalname");
  const [createDisabled, setCreateDisabled] = useState(false);
  const [selectedValueAmount, setSelectedValueAmount] =
    useState("defaultAmount");
  const [accountNameValidation, setAccountNameValidation] = useState(true);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [selectedCatFields, setSelectedCatFields] = useState([]);
  const [direction, setDirection] = useState(null);
  const [removeClassName, setRemoveClassName] = useState(true);
  const [recipients, setRecipients] = useState([]);
  const [createRecipient, setCreateRecipient] = useState([]);
  const [showRupeeSymbol, setShowRupeeSymbol] = useState(false);
  const isVerifiedPan = verifiedPan === true;
  const shouldLookupNext = lookupNext === true;
  const isBeneLookDataNull = panLookupData === null;
  const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
  const isIFSCValid =
    payload?.ifsc_code?.length === GlobalConfiguration.ifscLength &&
    ifscRegex.test(payload?.ifsc_code);

  const [virtualAccount, setVirtualAccount] = useState(false);
  const steps = [
    "User and contact details",
    "PAN details",
    "Bank details",
    "Account name",
    "Category, labels and recipients",
    "Confirm and create",
  ];
  const hasAssociatedAccounts = panLookupData !== null;
  const isGstEmpty =
    payload?.gstin?.length === GlobalConfiguration.lengthCheckZero;
  const isGstVerified =
    payload?.gstin?.length === GlobalConfiguration.gstLength &&
    GSTStatus === true;
  const isGstInvalid =
    payload?.gstin?.length > GlobalConfiguration.lengthCheckZero &&
    !isGstVerified;
  const isSwitchAccount = userData?.type === "switch_account";

  const isPrefilledPanValid =
    payload?.panNumber?.length === GlobalConfiguration.panLength;

  const isBankStatusValid = verifyBankAccountData?.status === true;
  const isBankAccountValid =
    payload?.bank_account?.length > GlobalConfiguration.lengthCheckZero;
  const isIfscCodeValid =
    payload?.ifsc_code?.length === GlobalConfiguration.ifscLength;
  const isVerifyBankValid = verifyBankAccountData?.status === true;
  const isUserName = payload?.userName !== "";
  const isPanName = payload?.account_name !== "";

  const isContactValid = contactBol.contact === true;
  const isEmailValid = contactBol.email === true;
  const isAccountNameValid = contactBol.accountname === true;

  const shouldEnableNextButtonSecondStepper =
    (isSwitchAccount && lookupNext && isPrefilledPanValid) ||
    (isVerifiedPan &&
      ((isBeneLookDataNull && (isGstEmpty || isGstVerified)) ||
        (hasAssociatedAccounts && shouldLookupNext) ||
        (isSwitchAccount && isGstEmpty)) &&
      !isGstInvalid);

  const shouldEnableNextButtonThirdStepper =
    (isSwitchAccount && isBankAccountValid && isIfscCodeValid) ||
    (!ifscDetailsLoading &&
      !bankLookupLoading &&
      !verifyBankAccountLoading &&
      isBankStatusValid &&
      isBankAccountValid &&
      isIfscCodeValid &&
      isVerifyBankValid &&
      (!bankLookupData?.beneficiary_accounts?.length || bankLookupNext));

  const shouldEnableNextButtonFirstStepper =
    isContactValid && isEmailValid && isUserName;

  const shouldEnableNextButtonFourStepper = isAccountNameValid && isPanName;

  const [remPan, setRemPan] = useState("");

  const [newData, setNewData] = useState({
    gstin: userData?.gstin || userData?.gstin_no || "",
  });

  const animationClass =
    direction === "next" ? "animate-slide-next" : "animate-slide-prev";

  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
  const specialRegex = /^[a-zA-Z0-9 ]*$/;

  const dataReceiveFromContact = (data) => {
    setContactBol(data);
  };

  const handleCreateAccount = async () => {
    if (createDisabled) return;

    setCreateDisabled(true);

    try {
      let updatedPayload = { ...payload, navigate };

      if (
        selectedFields.length === categoriesData?.categories?.length ||
        selectedFields.length === 0
      ) {
        updatedPayload.categories = null;
      } else {
        updatedPayload = {
          ...updatedPayload,
          categories: selectedFields.toString(),
        };
      }
      if (userData?.type !== "switch_account") {
        updatedPayload.category_ids =
          selectedCatFields.length === GlobalConfiguration.lengthCheckZero ||
          selectedCatFields.length === categories?.length
            ? []
            : selectedCatFields;
      }

      let data;
      if (userData?.type === "switch_account") {
        if (!updatedPayload?.linked_user_id) {
          CommonToast({
            text: "Please link a user before switching to field force account.",
            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
          });
          return;
        }

        data = await dispatch(
          editBeneficiary(
            buildSwitchFieldForceEditPayload({
              bene_acc_id,
              updatedPayload,
              navigate,
            }),
          ),
        ).unwrap();
      } else {
        data = await dispatch(createFieldForceAccount(updatedPayload)).unwrap();
      }

      const accountId = data?.field_force_accounts?.[0]?.id || bene_acc_id;

      if (data?.status === true) {
        navigate(
          `/field_force_account_dashboard/create_field_force_account/success/${accountId}`,
          {
            replace: true,
            state: { type: userData?.type },
          },
        );
      }
    } catch (error) {
      navigate(
        `/field_force_account_dashboard/create_field_force_account/error`,
        {
          replace: true,
          state: persistFieldForceCreateError(error),
        },
      );

      return error;
    } finally {
      setCreateDisabled(false);
    }
  };

  const handleMainCreate = () => {
    handleCreateAccount();
  };

  const renderCreateAccount = () => {
    switch (activeStep) {
      case 0:
        return (
          <FieldForceContactDetails
            payload={payload}
            selectedLabelsCreate={selectedLabelsCreate}
            setSelectedLabelsCreate={setSelectedLabelsCreate}
            setPayload={setPayload}
            categories={categories}
            onSelectFieldsChange={handleSelectFieldsChange}
            BenEnableNextButton={BenEnableNextButton}
            parentCreateBen={dataReceiveFromContact}
            activeStep={activeStep}
            showAlertCategories={showAlertCategories}
            setShowAlertCategories={setShowAlertCategories}
            handleNext={handleNext}
            selectedValue={selectedValue}
            setSelectedValue={setSelectedValue}
            accountNameValidation={accountNameValidation}
            setAccountNameValidation={setAccountNameValidation}
            selectAllChecked={selectAllChecked}
            setSelectAllChecked={setSelectAllChecked}
            selectedCatFields={selectedCatFields}
            setSelectedCatFields={setSelectedCatFields}
            flow={flow}
            showRupeeSymbol={showRupeeSymbol}
            setShowRupeeSymbol={setShowRupeeSymbol}
            selectedValueAmount={selectedValueAmount}
            setSelectedValueAmount={setSelectedValueAmount}
          />
        );
      case 1:
        return (
          <CreateFieldForcePanDetails
            panNumber={payload.panNumber}
            verifiedPan={verifiedPan}
            handlePanChange={handlePanChange}
            panDetails={panVerificationData?.pan_details}
            beneLookData={panLookupData}
            beneLookLoading={panLookupLoading}
            lookupNext={lookupNext}
            setLookupNext={setLookupNext}
            BenEnableNextButton={BenEnableNextButton}
            verifyPANisLoading={panVerificationLoading}
            disableCreateNext={disableCreateNext}
            setDisableCreateNext={setDisableCreateNext}
            type={userData?.type}
            previousId={bene_acc_id}
            beneLookError={panLookupError}
            hideBlock={hideBlock}
            setPayload={setPayload}
            payload={payload}
            GSTStatus={GSTStatus}
            setGSTStatus={setGSTStatus}
            setNewData={setNewData}
          />
        );
      case 2:
        return (
          <FieldFieldBankDetails
            setBankLookupNext={setBankLookupNext}
            bankLookupNext={bankLookupNext}
            nextButtonEnabled={nextButtonEnabled}
            BenEnableNextButton={BenEnableNextButton}
            payload={payload}
            setPayload={setPayload}
            activeStep={activeStep}
            ownerAccIfscError={ifscDetailsError}
            manualVirtualAccount={manualVirtualAccount}
            setManualVirtualAccount={setManualVirtualAccount}
            ownerAccIfscData={ifscDetailsData}
            hideBankBlock={hideBankBlock}
            setBankHideBlock={setBankHideBlock}
            isButtonDisabled={isButtonDisabled}
            setBankUserInfo={setBankUserInfo}
            bankVerificationStatus={bankVerificationStatus}
            setBankVerificationStatus={setBankVerificationStatus}
            isIFSCValid={isIFSCValid}
            isBankError={verifyBankAccountError}
            virtualAccount={virtualAccount}
            setVirtualAccount={setVirtualAccount}
            previousId={bene_acc_id}
            setPreviousBankNo={() => {}}
            type={userData?.type}
          />
        );
      case 3:
        return (
          <FieldForceAccountName
            payload={payload}
            selectedValue={selectedValue}
            setSelectedValue={setSelectedValue}
            accountNameValidation={accountNameValidation}
            setAccountNameValidation={setAccountNameValidation}
            setPayload={setPayload}
            parentCreateBen={dataReceiveFromContact}
            activeStep={activeStep}
            BenEnableNextButton={BenEnableNextButton}
          />
        );
      case 4:
        return (
          <FieldForceCategoryAndLabels
            payload={payload}
            selectedLabelsCreate={selectedLabelsCreate}
            setSelectedLabelsCreate={setSelectedLabelsCreate}
            setPayload={setPayload}
            categories={categories}
            onSelectFieldsChange={handleSelectFieldsChange}
            BenEnableNextButton={BenEnableNextButton}
            parentCreateBen={dataReceiveFromContact}
            activeStep={activeStep}
            showAlertCategories={showAlertCategories}
            setShowAlertCategories={setShowAlertCategories}
            handleNext={handleNext}
            selectedValue={selectedValue}
            setSelectedValue={setSelectedValue}
            accountNameValidation={accountNameValidation}
            setAccountNameValidation={setAccountNameValidation}
            selectAllChecked={selectAllChecked}
            setSelectAllChecked={setSelectAllChecked}
            selectedCatFields={selectedCatFields}
            setSelectedCatFields={setSelectedCatFields}
            createRecipient={createRecipient}
            setCreateRecipient={setCreateRecipient}
            recipients={recipients}
            setRecipients={setRecipients}
            type={userData?.type}
          />
        );
      case 5:
        return (
          <FieldForceConfirmAccount
            payload={payload}
            selectedFields={selectedFields}
            selectedCatFields={selectedCatFields}
            bankAccountName={bankAccountName}
            setShowModalPopup={setShowModalPopup}
            showModalPopup={showModalPopup}
            bankUserInfo={bankUserInfo}
            recipients={createRecipient}
            flow={flow}
            remPan={remPan}
            createFieldForceAccountLoading={createFieldForceAccountLoading}
            setRemPan={setRemPan}
            manualVirtualAccount={manualVirtualAccount}
            type={userData?.type}
            bene_acc_id={bene_acc_id}
          />
        );
      default:
        return null;
    }
  };

  const handleKeyDown = (event) => {
    if (event.target.tagName === "INPUT") {
    } else if (
      event.key === "ArrowLeft" ||
      event.key === "ArrowRight" ||
      event.key === "Tab" ||
      event.key === " "
    ) {
      event.preventDefault();
    }
  };

  const handleNext = () => {
    if (
      activeStep === GlobalConfiguration.lengthCheckFour &&
      selectedFields?.length === categories?.length &&
      !showAlertCategories
    ) {
      if (userData?.type === "switch_account") {
        setShowAlertCategories(false);
      } else {
        setShowAlertCategories(true);
      }
      setSelectedLabelsCreate(selectedLabelsCreate || []);
    } else if (activeStep === GlobalConfiguration.lengthCheckFive) {
      handleMainCreate();
    } else {
      setShowAlertCategories(false);
      setActiveStep(
        (prevActiveStep) => prevActiveStep + GlobalConfiguration.lengthCheckOne,
      );
      setDirection("next");
      setRemoveClassName(false);
      setTimeout(() => {
        setRemoveClassName(true);
      }, GlobalConfiguration.delayTime);
    }
  };

  // Example

  console.log(payload);

  const handleBack = () => {
    if (activeStep === GlobalConfiguration?.lengthCheckZero) {
      if (
        payload?.contact_no?.length > GlobalConfiguration?.lengthCheckZero ||
        payload?.email_id?.length > GlobalConfiguration?.lengthCheckZero ||
        payload?.userId?.length > GlobalConfiguration?.lengthCheckZero
      ) {
        setExitFlow(true);

        return;
      } else {
        setExitFlow(false);
        navigate(GlobalConfiguration?.lengthCheckNegativeOne);
        return;
      }
    }
    setActiveStep(
      (prevActiveStep) => prevActiveStep - GlobalConfiguration?.lengthCheckOne,
    );
    setDirection("previous");
    setRemoveClassName(false);
    setTimeout(() => {
      setRemoveClassName(true);
    }, GlobalConfiguration.delayTime);
  };

  const handleSelectFieldsChange = (selectedFields) => {
    setSelectedFields(selectedFields);
  };

  const handlePanChange = (e) => {
    setSelectedValue("legalname");
    const inputPan = e.target.value.toUpperCase();

    if (!specialRegex.test(inputPan)) {
      return;
    }

    if (inputPan.length > GlobalConfiguration.panLength) {
      return;
    }
    dispatch(resetPANVerification());
    if (
      !panRegex.test(inputPan) &&
      inputPan.length === GlobalConfiguration.panLength
    ) {
      setVerifiedPan(false);
      dispatch(resetPanLookup());
    } else if (inputPan.length === GlobalConfiguration.panLength) {
      dispatch(verifyPAN({ pan_number: inputPan, showToast: false }));
      setGSTStatus(null);
    } else {
      setVerifiedPan(null);
      BenEnableNextButton(true);
      setLookupNext(false);
    }

    setPayload({
      ...payload,
      panNumber: inputPan,
      gstin: userData?.gstin || "",
    });
    setDisableCreateNext(false);
    setLookupNext(false);
    setHideBlock(false);
    dispatch(resetGSTVerification());
    // dispatch(resetPANVerification());
  };

  // Enter-key navigation, mirrored from the Reimbursement Account create flow:
  // useCallback so the listener always sees fresh activeStep / validity flags
  // instead of the stale closure the old inline handler had (empty-deps bug).
  const handleEnterKeyPress = useCallback(
    (e) => {
      if (e.key !== "Enter") return;

      e.preventDefault();
      e.stopPropagation();

      if (
        activeStep === GlobalConfiguration?.lengthCheckZero &&
        shouldEnableNextButtonFirstStepper
      ) {
        handleNext();
        return;
      } else if (
        activeStep === GlobalConfiguration?.lengthCheckOne &&
        shouldEnableNextButtonSecondStepper
      ) {
        handleNext();
        return;
      } else if (
        activeStep === GlobalConfiguration?.lengthCheckTwo &&
        shouldEnableNextButtonThirdStepper
      ) {
        handleNext();
        return;
      } else if (
        activeStep === GlobalConfiguration?.lengthCheckThree &&
        shouldEnableNextButtonFourStepper
      ) {
        handleNext();
      } else if (activeStep === GlobalConfiguration?.lengthCheckFour) {
        if (selectedFields?.length === categories?.length) {
          setShowAlertCategories(true);
        } else {
          handleNext();
          return;
        }
      }

      if (activeStep === GlobalConfiguration?.lengthCheckFour) {
        handleMainCreate();
      }
    },
    [
      activeStep,
      handleNext,
      shouldEnableNextButtonFirstStepper,
      shouldEnableNextButtonSecondStepper,
      shouldEnableNextButtonThirdStepper,
      shouldEnableNextButtonFourStepper,
      selectedFields,
      categories,
    ],
  );

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    setRemPan(payload.panNumber);
  }, [payload.panNumber]);

  useEffect(() => {
    dispatch(getAllCategories());
  }, []);

  // Was: useEffect(..., []) with the old inline handler -> stale activeStep forever.
  // Now re-attaches whenever handleEnterKeyPress changes (i.e. whenever its deps change),
  // so Enter always acts on the current step.
  useEffect(() => {
    document.addEventListener("keydown", handleEnterKeyPress);
    return () => {
      document.removeEventListener("keydown", handleEnterKeyPress);
    };
  }, [handleEnterKeyPress]);

  // Mirrors reimbursement flow: while the confirm modal is open, Enter should
  // trigger account creation instead of the step-navigation handler above.
  useEffect(() => {
    if (!showModalPopup) return;

    const handleModalEnterKeyPress = (e) => {
      if (e.key !== "Enter") return;
      e.preventDefault();
      e.stopPropagation();
      handleCreateAccount();
    };

    document.addEventListener("keydown", handleModalEnterKeyPress);

    return () => {
      document.removeEventListener("keydown", handleModalEnterKeyPress);
    };
  }, [showModalPopup]);

  useEffect(() => {
    if (!panVerificationLoading) {
      if (panVerificationData?.status === true) {
        setVerifiedPan(true);

        dispatch(panLookUp({ pan_number: payload.panNumber }));
        setPayload({
          ...payload,
          legalName: panVerificationData?.pan_details?.full_name,
          account_name: panVerificationData?.pan_details?.full_name,
        });
      } else if (
        panVerificationData?.status === false &&
        payload?.panNumber.length === GlobalConfiguration.panLength
      ) {
        setVerifiedPan(false);
      }
    }
  }, [panVerificationData]);

  useEffect(() => {
    if (!verifyBankAccountLoading) {
      if (verifyBankAccountData?.status === true) {
        setBankAccountName(true);
        setBankAccountName(
          verifyBankAccountData?.verification_details[
            GlobalConfiguration.lengthCheckZero
          ]?.full_name,
        );
      }
    }
  }, [verifyBankAccountData]);

  useEffect(() => {
    return () => {
      dispatch(resetPANVerification());
      setVerifiedPan(null);
    };
  }, []);

  useEffect(() => {
    if (
      bankLookupData?.status &&
      activeStep === GlobalConfiguration.lengthCheckOne
    ) {
      BenEnableNextButton(true);
    }
  }, [bankLookupData]);

  useEffect(() => {
    if (payload.ifsc_code?.length < GlobalConfiguration.ifscLength) {
      dispatch(resetBankVerificationError());
    }
    if (
      payload.bank_account?.length < GlobalConfiguration.accountnormalLength
    ) {
      const obj = { ...payload, ifsc_code: "" };
      setPayload(obj);
    }
    if (
      payload.bank_account?.length === 0 &&
      payload.ifsc_code?.length > GlobalConfiguration.lengthCheckZero
    ) {
      const newObj = { ...payload, ifsc_code: "" };
      setPayload(newObj);
      //  setBankVerificationStatus(false);
      BenEnableNextButton(true);
      dispatch(resetBankVerificationError());
    }
    if (
      payload.bank_account?.length >= GlobalConfiguration.accountnormalLength &&
      payload.ifsc_code?.length === GlobalConfiguration.ifscLength &&
      /^[A-Z]{4}0[A-Z0-9]{6}$/.test(payload.ifsc_code)
    ) {
      dispatch(
        verifyBankAccount({
          ifsc_code: payload.ifsc_code,
          bank_account: payload.bank_account,
          legal_name: payload.legalName,
        }),
      );
      dispatch(
        getIFSCDetails({
          search_string: payload?.ifsc_code,
          page_no: GlobalConfiguration?.lengthCheckOne,
          page_size: GlobalConfiguration?.filterResults,
        }),
      );
    }
    if (
      createRecipient &&
      createRecipient.length > GlobalConfiguration.lengthCheckZero
    ) {
      setPayload((prev) => ({
        ...prev,
        recipient_email: createRecipient.join(","),
      }));
    } else {
      setPayload((prev) => {
        const updated = { ...prev };
        delete updated.recipient_email;
        return updated;
      });
    }
  }, [
    payload.ifsc_code,
    payload.bank_account,
    payload.legalName,
    createRecipient,
  ]);

  useEffect(() => {
    if (verifyBankAccountData?.status === true) {
      dispatch(
        bankLookUp({
          ifsc: payload.ifsc_code,
          bank_account_no: payload.bank_account,
        }),
      );
    }
  }, [verifyBankAccountData]);
  useEffect(() => {
    if (
      location?.state?.bank_acc_no &&
      location?.state?.ifsc_code &&
      location?.state?.type === "switch_account"
    ) {
      setBankLookupNext(true);
      return;
    }

    if (!bankLookupLoading) {
      setTimeout(() => {
        if (isIFSCValid && !verifyBankAccountError) {
          if (
            bankLookupData?.beneficiary_accounts?.length >
            GlobalConfiguration?.lengthCheckZero
          ) {
            setBankLookupNext(false);
          } else if (
            !verifyBankAccountLoading &&
            verifyBankAccountData?.status &&
            virtualAccount
          ) {
            setBankLookupNext(true);
          }
        }
      }, 0);
    }
  }, [
    bankLookupLoading,
    bankLookupData,
    verifyBankAccountError,
    isIFSCValid,
    virtualAccount,
    verifyBankAccountLoading,
    verifyBankAccountData,
    location?.state?.type,
    location?.state?.bank_acc_no,
    location?.state?.ifsc_code,
  ]);

  useEffect(() => {
    if (userData?.type === "switch_account" && userData?.id) {
      dispatch(viewAccountDetail({ id: userData.id }));
    }
  }, [userData?.type, userData?.id, dispatch]);

  useEffect(() => {
    if (isLoading || !services) return;

    if (!services.includes("FFUAccount")) {
      navigate("/feature_not_assigned", {
        state: { unavailableService: "FFUAccount" },
      });
    }
  }, [services, isLoading, navigate]);

  useEffect(() => {
    if (activeStep === GlobalConfiguration.lengthCheckZero) {
      BenEnableNextButton(!shouldEnableNextButtonFirstStepper);
    } else if (activeStep === GlobalConfiguration.lengthCheckOne) {
      const canEnableSwitchPanStep =
        isSwitchAccount && lookupNext && isPrefilledPanValid;

      if (canEnableSwitchPanStep || !panLookupLoading) {
        BenEnableNextButton(!shouldEnableNextButtonSecondStepper);
      }
    } else if (activeStep === GlobalConfiguration.lengthCheckTwo) {
      BenEnableNextButton(!shouldEnableNextButtonThirdStepper);
    } else if (activeStep === GlobalConfiguration.lengthCheckThree) {
      BenEnableNextButton(!shouldEnableNextButtonFourStepper);
    } else if (activeStep === GlobalConfiguration.lengthCheckFour) {
      BenEnableNextButton(false);
    } else if (activeStep === GlobalConfiguration.lengthCheckFive) {
      BenEnableNextButton(false);
    }
  }, [
    activeStep,
    verifyBankAccountData?.status,
    contactBol?.contact,
    contactBol?.email,
    payload?.bank_account,
    payload?.ifsc_code,
    payload?.gstin,
    verifiedPan,
    verifyBankAccountData?.status,
    bankLookupNext,
    panLookupData,
    lookupNext,
    isSwitchAccount,
    isPrefilledPanValid,
    shouldEnableNextButtonFirstStepper,
    shouldEnableNextButtonSecondStepper,
    shouldEnableNextButtonThirdStepper,
    shouldEnableNextButtonFourStepper,
    panLookupLoading,
    selectedFields,
    categories,
    showAlertCategories,
    bankLookupLoading,
    bankLookupData,
    manualVirtualAccount,
  ]);

  useEffect(() => {
    if (newData.gstin?.length !== GlobalConfiguration.gstinLength) {
      setLookupNext(false);
    }
  }, [payload.gstin]);

  useEffect(() => {
    if (location?.state?.pan && location?.state?.type === "switch_account") {
      handlePanChange({ target: { value: location.state.pan } });
      setDisableCreateNext(true);
      setLookupNext(true);
    }
  }, [location?.state?.type]);

  const dataArray = [
    {
      previousText: "Cancel",
      nextText: "Next",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--text-primary)",
      previousDisableBgColor: "var(--primary-nav-act)",
      nextDisableBgColor: "var(--text-disabled)",
      nextEnableTextColor: "var(--primary-bg)",
      nextDisableTextColor: "var(--text-primary)",
      previousEnableTextColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      nextIsLoading: false,
      nextIsEnabled: !nextButtonEnabled && !isButtonDisabled,
      stepperText: steps[GlobalConfiguration.lengthCheckZero],
    },
    {
      previousText: "Previous",
      nextText: "Next",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--text-primary)",
      previousDisableBgColor: "var(--primary-nav-act)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextEnableTextColor: "var(--primary-bg)",
      previousEnableTextColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      nextIsLoading: false,
      nextIsEnabled: !nextButtonEnabled && !isButtonDisabled,
      stepperText: steps[GlobalConfiguration.lengthCheckOne],
    },
    {
      previousText: "Previous",
      nextText: "Next",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--text-primary)",
      previousDisableBgColor: "var(--primary-nav-act)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextEnableTextColor: "var(--primary-bg)",
      previousEnableTextColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      nextIsLoading: false,
      nextIsEnabled:
        (!nextButtonEnabled &&
          !isButtonDisabled &&
          !verifyBankAccountLoading) ||
        manualVirtualAccount,
      stepperText: steps[GlobalConfiguration.lengthCheckTwo],
    },
    {
      previousText: "Previous",
      nextText: "Next",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--text-primary)",
      previousDisableBgColor: "var(--primary-nav-act)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextEnableTextColor: "var(--primary-bg)",
      previousEnableTextColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      nextIsLoading: false,
      nextIsEnabled: !nextButtonEnabled && !isButtonDisabled,
      stepperText: steps[GlobalConfiguration.lengthCheckThree],
    },
    {
      previousText: "Previous",
      nextText: "Next",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--text-primary)",
      previousDisableBgColor: "var(--primary-nav-act)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextEnableTextColor: "var(--primary-bg)",
      previousEnableTextColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      nextIsLoading: false,
      nextIsEnabled: !nextButtonEnabled && !isButtonDisabled,
      stepperText: steps[GlobalConfiguration.lengthCheckFour],
    },
    {
      previousText: "Previous",
      nextText: "Create",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--positive-act)",
      previousDisableBgColor: "var(--primary-nav-act)",
      nextDisableBgColor: "var(--positive-act)",
      nextDisableTextColor: "var(--text-primary)",
      nextEnableTextColor: "var(--text-primary)",
      previousEnableTextColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      nextIsLoading: createFieldForceAccountLoading,
      nextIsEnabled: !nextButtonEnabled && !createDisabled,
      stepperText: steps[GlobalConfiguration.lengthCheckFive],
      nextLoaderNeeded: true,
    },
  ];

  return (
    <>
      {exitFlow && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop bg-opacity-dark-opacity justify-center z-z-index-modal">
          <SmallPopup
            headerTitle={"Confirm leaving this page?"}
            headerFontWeight="semibold"
            headerFontColor="negative-act"
            textSize="font-md"
            subtext="Leaving this page will not update the changes made."
            btnOneText="Stay"
            btnOneBtnType="button"
            btnOneEnabledBgColor="transparent"
            btnOneHandleFunction={() => setExitFlow(false)}
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText="Leave"
            btnTwoBtnType="button"
            btnTwoHandleFunction={() =>
              navigate(GlobalConfiguration?.lengthCheckNegativeOne)
            }
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoHoverOption="black"
          />
        </div>
      )}
      {showAlertCategories && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
          <SmallPopupWithBulletPoints
            headerTitle={"Unsafe to proceed"}
            bulletPoints={[
              "All categories will be linked to a single account.",
              "It is recommended to distribute categories across appropriate accounts.",
            ]}
            headerFontWeight="semibold"
            headerFontColor="negative-act"
            textSize="font-md"
            btnOneText="Cancel"
            btnOneBtnType="button"
            btnOneEnabledBgColor="transparent"
            btnOneHandleFunction={() => setShowAlertCategories(false)}
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText="Proceed"
            btnTwoBtnType="button"
            btnTwoHandleFunction={() => handleNext()}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoHoverOption="black"
          />
        </div>
      )}
      <div className="w-width-full flex flex-col items-center h-full-height bg-primary-bg">
        <div className="w-width-full">
          <div className="h-navbar-height hidden Qsmd:block"></div>
          <div className="h-[calc(var(--navbar-breadcrumb-height)-var(--navbar-height))] mt-margin-sm Qsmd:my-margin-base"></div>
        </div>
        <div className="flex justify-center items-end !bottom-bottom-base rounded-t-border-radius-md Qsmd:relative min-h-stepper-moble-height Qlg:bg-transparent bg-primary-nav rounded-b-border-radius-md w-screen fixed Qsmd:top-top-base left-left-base z-z-index-header">
          <PrimaryStepper
            activeStep={activeStep}
            handleForwardAction={handleNext}
            handleBackwardAction={handleBack}
            dataArray={dataArray}
          />
        </div>
        <div className="flex items-center w-width-full bg-primary-nav p-padding-sm fixed left-left-base top-top-base z-z-index-header Qsmd:hidden shadow-box-shadow-bottom">
          <div
            onClick={() => navigate(GlobalConfiguration.lengthCheckNegativeOne)}
          >
            <SVGComponent
              url={ICONS?.ARROW_LEFT_WHITE}
              color={"var(--text-primary)"}
              height={"var(--icon-md)"}
              width={"var(--icon-md)"}
              alt="Arrow"
            />
          </div>

          <div className=" flex flex-col pl-padding-md ">
            <p className=" text-font-md font-sans text-text-primary">
              {" "}
              Field Force Account
            </p>
            {activeStep === GlobalConfiguration.lengthCheckZero && (
              <p className="text-font-xs font-sans text-text-primary">
                {" "}
                User and contact details
              </p>
            )}
            {activeStep === GlobalConfiguration.lengthCheckOne && (
              <p className="text-font-xs font-sans text-text-primary">
                {" "}
                PAN details
              </p>
            )}
            {activeStep === GlobalConfiguration.lengthCheckTwo && (
              <p className="text-font-xs font-sans text-text-primary">
                {" "}
                Bank details
              </p>
            )}
            {activeStep === GlobalConfiguration.lengthCheckThree && (
              <p className="text-font-xs font-sans text-text-primary">
                {" "}
                Account name
              </p>
            )}
            {activeStep === GlobalConfiguration.lengthCheckFour && (
              <p className="text-font-xs font-sans text-text-primary">
                {" "}
                Category, labels and recipients
              </p>
            )}
            {activeStep === GlobalConfiguration.lengthCheckFive && (
              <p className="text-font-xs font-sans text-text-primary">
                {" "}
                Confirm and create
              </p>
            )}
          </div>
        </div>

        <>
          <div
            className="max-w-tab-width-normal mx-auto overflow-hidden h-full flex flex-col items-center relative w-width-full"
            ref={scrollIt}
          >
            {/* <div className="h-mobile-create-header w-width-full hidden Qsmd:block flex-shrink-0"></div> */}
            <div
              className={`w-width-full h-full overflow-auto Qsmd:pt-padding-md Qsmd:pb-padding-md pt-padding-base pb-padding-sm ${
                activeStep === GlobalConfiguration.lengthCheckZero &&
                direction === "next"
                  ? ""
                  : removeClassName === true
                    ? ""
                    : animationClass
              }`}
              style={{
                scrollbarWidth: "none",
              }}
            >
              {renderCreateAccount()}
            </div>
          </div>
        </>
        <div className="h-mobile-create-header flex-shrink-0 w-width-full Qsmd:hidden block"></div>
      </div>
    </>
  );
};

export default FieldForceAccountCreate;
